
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5b70"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5b70"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8mHfG", function(module, exports) {

$parcel$export(module.exports, "WebGLPathTracer", () => $6171edc1778f11e8$export$3a05a7fb86d40d58);

var $ilwiq = parcelRequire("ilwiq");

var $hWj76 = parcelRequire("hWj76");

var $hWds8 = parcelRequire("hWds8");

var $RPVlj = parcelRequire("RPVlj");

var $bHiTZ = parcelRequire("bHiTZ");

var $9wqOU = parcelRequire("9wqOU");

var $5rCKZ = parcelRequire("5rCKZ");

var $5VY8i = parcelRequire("5VY8i");
function $6171edc1778f11e8$var$supportsFloatBlending(renderer) {
    return renderer.extensions.get("EXT_float_blend");
}
const $6171edc1778f11e8$var$_resolution = new (0, $ilwiq.Vector2)();
class $6171edc1778f11e8$export$3a05a7fb86d40d58 {
    get multipleImportanceSampling() {
        return Boolean(this._pathTracer.material.defines.FEATURE_MIS);
    }
    set multipleImportanceSampling(v) {
        this._pathTracer.material.setDefine("FEATURE_MIS", v ? 1 : 0);
    }
    get transmissiveBounces() {
        return this._pathTracer.material.transmissiveBounces;
    }
    set transmissiveBounces(v) {
        this._pathTracer.material.transmissiveBounces = v;
    }
    get bounces() {
        return this._pathTracer.material.bounces;
    }
    set bounces(v) {
        this._pathTracer.material.bounces = v;
    }
    get filterGlossyFactor() {
        return this._pathTracer.material.filterGlossyFactor;
    }
    set filterGlossyFactor(v) {
        this._pathTracer.material.filterGlossyFactor = v;
    }
    get samples() {
        return this._pathTracer.samples;
    }
    get target() {
        return this._pathTracer.target;
    }
    get tiles() {
        return this._pathTracer.tiles;
    }
    get stableNoise() {
        return this._pathTracer.stableNoise;
    }
    set stableNoise(v) {
        this._pathTracer.stableNoise = v;
    }
    get isCompiling() {
        return Boolean(this._pathTracer.isCompiling);
    }
    constructor(renderer){
        // members
        this._renderer = renderer;
        this._generator = new (0, $hWj76.PathTracingSceneGenerator)();
        this._pathTracer = new (0, $hWds8.PathTracingRenderer)(renderer);
        this._queueReset = false;
        this._clock = new (0, $ilwiq.Clock)();
        this._compilePromise = null;
        this._lowResPathTracer = new (0, $hWds8.PathTracingRenderer)(renderer);
        this._lowResPathTracer.tiles.set(1, 1);
        this._quad = new (0, $RPVlj.FullScreenQuad)(new (0, $5rCKZ.ClampedInterpolationMaterial)({
            map: null,
            transparent: true,
            blending: (0, $ilwiq.NoBlending),
            premultipliedAlpha: renderer.getContextAttributes().premultipliedAlpha
        }));
        this._materials = null;
        this._previousEnvironment = null;
        this._previousBackground = null;
        this._internalBackground = null;
        // options
        this.renderDelay = 100;
        this.minSamples = 5;
        this.fadeDuration = 500;
        this.enablePathTracing = true;
        this.pausePathTracing = false;
        this.dynamicLowRes = false;
        this.lowResScale = 0.25;
        this.renderScale = 1;
        this.synchronizeRenderSize = true;
        this.rasterizeScene = true;
        this.renderToCanvas = true;
        this.textureSize = new (0, $ilwiq.Vector2)(1024, 1024);
        this.rasterizeSceneCallback = (scene, camera)=>{
            this._renderer.render(scene, camera);
        };
        this.renderToCanvasCallback = (target, renderer, quad)=>{
            const currentAutoClear = renderer.autoClear;
            renderer.autoClear = false;
            quad.render(renderer);
            renderer.autoClear = currentAutoClear;
        };
        // initialize the scene so it doesn't fail
        this.setScene(new (0, $ilwiq.Scene)(), new (0, $ilwiq.PerspectiveCamera)());
    }
    setBVHWorker(worker) {
        this._generator.setBVHWorker(worker);
    }
    setScene(scene, camera, options = {}) {
        scene.updateMatrixWorld(true);
        camera.updateMatrixWorld();
        const generator = this._generator;
        generator.setObjects(scene);
        if (this._buildAsync) return generator.generateAsync(options.onProgress).then((result)=>{
            return this._updateFromResults(scene, camera, result);
        });
        else {
            const result = generator.generate();
            return this._updateFromResults(scene, camera, result);
        }
    }
    setSceneAsync(...args) {
        this._buildAsync = true;
        const result = this.setScene(...args);
        this._buildAsync = false;
        return result;
    }
    setCamera(camera) {
        this.camera = camera;
        this.updateCamera();
    }
    updateCamera() {
        const camera = this.camera;
        camera.updateMatrixWorld();
        this._pathTracer.setCamera(camera);
        this._lowResPathTracer.setCamera(camera);
        this.reset();
    }
    updateMaterials() {
        const material = this._pathTracer.material;
        const renderer = this._renderer;
        const materials = this._materials;
        const textureSize = this.textureSize;
        // reduce texture sources here - we don't want to do this in the
        // textures array because we need to pass the textures array into the
        // material target
        const textures = (0, $9wqOU.getTextures)(materials);
        material.textures.setTextures(renderer, textures, textureSize.x, textureSize.y);
        material.materials.updateFrom(materials, textures);
        this.reset();
    }
    updateLights() {
        const scene = this.scene;
        const renderer = this._renderer;
        const material = this._pathTracer.material;
        const lights = (0, $9wqOU.getLights)(scene);
        const iesTextures = (0, $9wqOU.getIesTextures)(lights);
        material.lights.updateFrom(lights, iesTextures);
        material.iesProfiles.setTextures(renderer, iesTextures);
        this.reset();
    }
    updateEnvironment() {
        const scene = this.scene;
        const material = this._pathTracer.material;
        if (this._internalBackground) {
            this._internalBackground.dispose();
            this._internalBackground = null;
        }
        // update scene background
        material.backgroundBlur = scene.backgroundBlurriness;
        material.backgroundIntensity = scene.backgroundIntensity ?? 1;
        material.backgroundRotation.makeRotationFromEuler(scene.backgroundRotation).invert();
        if (scene.background === null) {
            material.backgroundMap = null;
            material.backgroundAlpha = 0;
        } else if (scene.background.isColor) {
            this._colorBackground = this._colorBackground || new (0, $bHiTZ.GradientEquirectTexture)(16);
            const colorBackground = this._colorBackground;
            if (!colorBackground.topColor.equals(scene.background)) {
                // set the texture color
                colorBackground.topColor.set(scene.background);
                colorBackground.bottomColor.set(scene.background);
                colorBackground.update();
            }
            // assign to material
            material.backgroundMap = colorBackground;
            material.backgroundAlpha = 1;
        } else if (scene.background.isCubeTexture) {
            if (scene.background !== this._previousBackground) {
                const background = new (0, $5VY8i.CubeToEquirectGenerator)(this._renderer).generate(scene.background);
                this._internalBackground = background;
                material.backgroundMap = background;
                material.backgroundAlpha = 1;
            }
        } else {
            material.backgroundMap = scene.background;
            material.backgroundAlpha = 1;
        }
        // update scene environment
        material.environmentIntensity = scene.environment !== null ? scene.environmentIntensity ?? 1 : 0;
        material.environmentRotation.makeRotationFromEuler(scene.environmentRotation).invert();
        if (this._previousEnvironment !== scene.environment) {
            if (scene.environment !== null) {
                if (scene.environment.isCubeTexture) {
                    const environment = new (0, $5VY8i.CubeToEquirectGenerator)(this._renderer).generate(scene.environment);
                    material.envMapInfo.updateFrom(environment);
                } else // TODO: Consider setting this to the highest supported bit depth by checking for
                // OES_texture_float_linear or OES_texture_half_float_linear. Requires changes to
                // the equirect uniform
                material.envMapInfo.updateFrom(scene.environment);
            }
        }
        this._previousEnvironment = scene.environment;
        this._previousBackground = scene.background;
        this.reset();
    }
    _updateFromResults(scene, camera, results) {
        const { materials: materials, geometry: geometry, bvh: bvh, bvhChanged: bvhChanged, needsMaterialIndexUpdate: needsMaterialIndexUpdate } = results;
        this._materials = materials;
        const pathTracer = this._pathTracer;
        const material = pathTracer.material;
        if (bvhChanged) {
            material.bvh.updateFrom(bvh);
            material.attributesArray.updateFrom(geometry.attributes.normal, geometry.attributes.tangent, geometry.attributes.uv, geometry.attributes.color);
        }
        if (needsMaterialIndexUpdate) material.materialIndexAttribute.updateFrom(geometry.attributes.materialIndex);
        // save previously used items
        this._previousScene = scene;
        this.scene = scene;
        this.camera = camera;
        this.updateCamera();
        this.updateMaterials();
        this.updateEnvironment();
        this.updateLights();
        return results;
    }
    renderSample() {
        const lowResPathTracer = this._lowResPathTracer;
        const pathTracer = this._pathTracer;
        const renderer = this._renderer;
        const clock = this._clock;
        const quad = this._quad;
        this._updateScale();
        if (this._queueReset) {
            pathTracer.reset();
            lowResPathTracer.reset();
            this._queueReset = false;
            quad.material.opacity = 0;
            clock.start();
        }
        // render the path tracing sample after enough time has passed
        const delta = clock.getDelta() * 1e3;
        const elapsedTime = clock.getElapsedTime() * 1e3;
        if (!this.pausePathTracing && this.enablePathTracing && this.renderDelay <= elapsedTime && !this.isCompiling) pathTracer.update();
        // when alpha is enabled we use a manual blending system rather than
        // rendering with a blend function
        pathTracer.alpha = pathTracer.material.backgroundAlpha !== 1 || !$6171edc1778f11e8$var$supportsFloatBlending(renderer);
        lowResPathTracer.alpha = pathTracer.alpha;
        if (this.renderToCanvas) {
            const renderer = this._renderer;
            const minSamples = this.minSamples;
            if (elapsedTime >= this.renderDelay && this.samples >= this.minSamples) {
                if (this.fadeDuration !== 0) quad.material.opacity = Math.min(quad.material.opacity + delta / this.fadeDuration, 1);
                else quad.material.opacity = 1;
            }
            // render the fallback if we haven't rendered enough samples, are paused, or are occluded
            if (!this.enablePathTracing || this.samples < minSamples || quad.material.opacity < 1) {
                if (this.dynamicLowRes && !this.isCompiling) {
                    if (lowResPathTracer.samples < 1) {
                        lowResPathTracer.material = pathTracer.material;
                        lowResPathTracer.update();
                    }
                    const currentOpacity = quad.material.opacity;
                    quad.material.opacity = 1 - quad.material.opacity;
                    quad.material.map = lowResPathTracer.target.texture;
                    quad.render(renderer);
                    quad.material.opacity = currentOpacity;
                }
                if (!this.dynamicLowRes && this.rasterizeScene || this.dynamicLowRes && this.isCompiling) this.rasterizeSceneCallback(this.scene, this.camera);
            }
            if (this.enablePathTracing && quad.material.opacity > 0) {
                if (quad.material.opacity < 1) // use additive blending when the low res texture is rendered so we can fade the
                // background out while the full res fades in
                quad.material.blending = this.dynamicLowRes ? (0, $ilwiq.AdditiveBlending) : (0, $ilwiq.NormalBlending);
                quad.material.map = pathTracer.target.texture;
                this.renderToCanvasCallback(pathTracer.target, renderer, quad);
                quad.material.blending = (0, $ilwiq.NoBlending);
            }
        }
    }
    reset() {
        this._queueReset = true;
        this._pathTracer.samples = 0;
    }
    dispose() {
        this._quad.dispose();
        this._quad.material.dispose();
        this._pathTracer.dispose();
    }
    _updateScale() {
        // update the path tracer scale if it has changed
        if (this.synchronizeRenderSize) {
            this._renderer.getDrawingBufferSize($6171edc1778f11e8$var$_resolution);
            const w = Math.floor(this.renderScale * $6171edc1778f11e8$var$_resolution.x);
            const h = Math.floor(this.renderScale * $6171edc1778f11e8$var$_resolution.y);
            this._pathTracer.getSize($6171edc1778f11e8$var$_resolution);
            if ($6171edc1778f11e8$var$_resolution.x !== w || $6171edc1778f11e8$var$_resolution.y !== h) {
                const lowResScale = this.lowResScale;
                this._pathTracer.setSize(w, h);
                this._lowResPathTracer.setSize(Math.floor(w * lowResScale), Math.floor(h * lowResScale));
            }
        }
    }
}

});
parcelRegister("bHiTZ", function(module, exports) {

$parcel$export(module.exports, "GradientEquirectTexture", () => $88425f7125b6e46c$export$38d6a241e670a287);

var $ilwiq = parcelRequire("ilwiq");

var $dbdMq = parcelRequire("dbdMq");
const $88425f7125b6e46c$var$_direction = new (0, $ilwiq.Vector3)();
class $88425f7125b6e46c$export$38d6a241e670a287 extends (0, $dbdMq.ProceduralEquirectTexture) {
    constructor(resolution = 512){
        super(resolution, resolution);
        this.topColor = new (0, $ilwiq.Color)().set(0xffffff);
        this.bottomColor = new (0, $ilwiq.Color)().set(0x000000);
        this.exponent = 2;
        this.generationCallback = (polar, uv, coord, color)=>{
            $88425f7125b6e46c$var$_direction.setFromSpherical(polar);
            const t = $88425f7125b6e46c$var$_direction.y * 0.5 + 0.5;
            color.lerpColors(this.bottomColor, this.topColor, t ** this.exponent);
        };
    }
    copy(other) {
        super.copy(other);
        this.topColor.copy(other.topColor);
        this.bottomColor.copy(other.bottomColor);
        return this;
    }
}

});
parcelRegister("dbdMq", function(module, exports) {

$parcel$export(module.exports, "ProceduralEquirectTexture", () => $9986fde00d79bc96$export$ab88b3c5fea10066);

var $ilwiq = parcelRequire("ilwiq");
const $9986fde00d79bc96$var$_uv = new (0, $ilwiq.Vector2)();
const $9986fde00d79bc96$var$_coord = new (0, $ilwiq.Vector2)();
const $9986fde00d79bc96$var$_polar = new (0, $ilwiq.Spherical)();
const $9986fde00d79bc96$var$_color = new (0, $ilwiq.Color)();
class $9986fde00d79bc96$export$ab88b3c5fea10066 extends (0, $ilwiq.DataTexture) {
    constructor(width = 512, height = 512){
        super(new Float32Array(width * height * 4), width, height, (0, $ilwiq.RGBAFormat), (0, $ilwiq.FloatType), (0, $ilwiq.EquirectangularReflectionMapping), (0, $ilwiq.RepeatWrapping), (0, $ilwiq.ClampToEdgeWrapping), (0, $ilwiq.LinearFilter), (0, $ilwiq.LinearFilter));
        this.generationCallback = null;
    }
    update() {
        this.dispose();
        this.needsUpdate = true;
        const { data: data, width: width, height: height } = this.image;
        for(let x = 0; x < width; x++)for(let y = 0; y < height; y++){
            $9986fde00d79bc96$var$_coord.set(width, height);
            $9986fde00d79bc96$var$_uv.set(x / width, y / height);
            $9986fde00d79bc96$var$_uv.x -= 0.5;
            $9986fde00d79bc96$var$_uv.y = 1.0 - $9986fde00d79bc96$var$_uv.y;
            $9986fde00d79bc96$var$_polar.theta = $9986fde00d79bc96$var$_uv.x * 2.0 * Math.PI;
            $9986fde00d79bc96$var$_polar.phi = $9986fde00d79bc96$var$_uv.y * Math.PI;
            $9986fde00d79bc96$var$_polar.radius = 1.0;
            this.generationCallback($9986fde00d79bc96$var$_polar, $9986fde00d79bc96$var$_uv, $9986fde00d79bc96$var$_coord, $9986fde00d79bc96$var$_color);
            const i = y * width + x;
            const i4 = 4 * i;
            data[i4 + 0] = $9986fde00d79bc96$var$_color.r;
            data[i4 + 1] = $9986fde00d79bc96$var$_color.g;
            data[i4 + 2] = $9986fde00d79bc96$var$_color.b;
            data[i4 + 3] = 1.0;
        }
    }
    copy(other) {
        super.copy(other);
        this.generationCallback = other.generationCallback;
        return this;
    }
}

});


parcelRegister("5rCKZ", function(module, exports) {

$parcel$export(module.exports, "ClampedInterpolationMaterial", () => $3f6d89af35c8e149$export$41f50d3add172b7d);

var $ilwiq = parcelRequire("ilwiq");
class $3f6d89af35c8e149$export$41f50d3add172b7d extends (0, $ilwiq.ShaderMaterial) {
    get map() {
        return this.uniforms.map.value;
    }
    set map(v) {
        this.uniforms.map.value = v;
    }
    get opacity() {
        return this.uniforms.opacity.value;
    }
    set opacity(v) {
        if (this.uniforms) this.uniforms.opacity.value = v;
    }
    constructor(params){
        super({
            uniforms: {
                map: {
                    value: null
                },
                opacity: {
                    value: 1
                }
            },
            vertexShader: /* glsl */ `
				varying vec2 vUv;
				void main() {

					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

				}
			`,
            fragmentShader: /* glsl */ `
				uniform sampler2D map;
				uniform float opacity;
				varying vec2 vUv;

				vec4 clampedTexelFatch( sampler2D map, ivec2 px, int lod ) {

					vec4 res = texelFetch( map, ivec2( px.x, px.y ), 0 );

					#if defined( TONE_MAPPING )

					res.xyz = toneMapping( res.xyz );

					#endif

			  		return linearToOutputTexel( res );

				}

				void main() {

					vec2 size = vec2( textureSize( map, 0 ) );
					vec2 pxUv = vUv * size;
					vec2 pxCurr = floor( pxUv );
					vec2 pxFrac = fract( pxUv ) - 0.5;
					vec2 pxOffset;
					pxOffset.x = pxFrac.x > 0.0 ? 1.0 : - 1.0;
					pxOffset.y = pxFrac.y > 0.0 ? 1.0 : - 1.0;

					vec2 pxNext = clamp( pxOffset + pxCurr, vec2( 0.0 ), size - 1.0 );
					vec2 alpha = abs( pxFrac );

					vec4 p1 = mix(
						clampedTexelFatch( map, ivec2( pxCurr.x, pxCurr.y ), 0 ),
						clampedTexelFatch( map, ivec2( pxNext.x, pxCurr.y ), 0 ),
						alpha.x
					);

					vec4 p2 = mix(
						clampedTexelFatch( map, ivec2( pxCurr.x, pxNext.y ), 0 ),
						clampedTexelFatch( map, ivec2( pxNext.x, pxNext.y ), 0 ),
						alpha.x
					);

					gl_FragColor = mix( p1, p2, alpha.y );
					gl_FragColor.a *= opacity;
					#include <premultiplied_alpha_fragment>

				}
			`
        });
        this.setValues(params);
    }
}

});

parcelRegister("5VY8i", function(module, exports) {

$parcel$export(module.exports, "CubeToEquirectGenerator", () => $4520ebc51d692c1e$export$6f8f537b668b4bb1);

var $ilwiq = parcelRequire("ilwiq");

var $RPVlj = parcelRequire("RPVlj");

var $dUUQZ = parcelRequire("dUUQZ");
class $4520ebc51d692c1e$var$CubeToEquirectMaterial extends (0, $ilwiq.ShaderMaterial) {
    constructor(){
        super({
            uniforms: {
                envMap: {
                    value: null
                },
                flipEnvMap: {
                    value: -1
                }
            },
            vertexShader: /* glsl */ `
				varying vec2 vUv;
				void main() {

					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

				}`,
            fragmentShader: /* glsl */ `
				#define ENVMAP_TYPE_CUBE_UV

				uniform samplerCube envMap;
				uniform float flipEnvMap;
				varying vec2 vUv;

				#include <common>
				#include <cube_uv_reflection_fragment>

				${$dUUQZ.util_functions}

				void main() {

					vec3 rayDirection = equirectUvToDirection( vUv );
					rayDirection.x *= flipEnvMap;
					gl_FragColor = textureCube( envMap, rayDirection );

				}`
        });
        this.depthWrite = false;
        this.depthTest = false;
    }
}
class $4520ebc51d692c1e$export$6f8f537b668b4bb1 {
    constructor(renderer){
        this._renderer = renderer;
        this._quad = new (0, $RPVlj.FullScreenQuad)(new $4520ebc51d692c1e$var$CubeToEquirectMaterial());
    }
    generate(source, width = null, height = null) {
        if (!source.isCubeTexture) throw new Error("CubeToEquirectMaterial: Source can only be cube textures.");
        const image = source.images[0];
        const renderer = this._renderer;
        const quad = this._quad;
        // determine the dimensions if not provided
        if (width === null) width = 4 * image.height;
        if (height === null) height = 2 * image.height;
        const target = new (0, $ilwiq.WebGLRenderTarget)(width, height, {
            type: (0, $ilwiq.FloatType),
            colorSpace: image.colorSpace
        });
        // prep the cube map data
        const imageHeight = image.height;
        const maxMip = Math.log2(imageHeight) - 2;
        const texelHeight = 1.0 / imageHeight;
        const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
        quad.material.defines.CUBEUV_MAX_MIP = `${maxMip}.0`;
        quad.material.defines.CUBEUV_TEXEL_WIDTH = texelWidth;
        quad.material.defines.CUBEUV_TEXEL_HEIGHT = texelHeight;
        quad.material.uniforms.envMap.value = source;
        quad.material.uniforms.flipEnvMap.value = source.isRenderTargetTexture ? 1 : -1;
        quad.material.needsUpdate = true;
        // save state and render the contents
        const currentTarget = renderer.getRenderTarget();
        const currentAutoClear = renderer.autoClear;
        renderer.autoClear = true;
        renderer.setRenderTarget(target);
        quad.render(renderer);
        renderer.setRenderTarget(currentTarget);
        renderer.autoClear = currentAutoClear;
        // read the data back
        const buffer = new Uint16Array(width * height * 4);
        const readBuffer = new Float32Array(width * height * 4);
        renderer.readRenderTargetPixels(target, 0, 0, width, height, readBuffer);
        target.dispose();
        for(let i = 0, l = readBuffer.length; i < l; i++)buffer[i] = (0, $ilwiq.DataUtils).toHalfFloat(readBuffer[i]);
        // produce the data texture
        const result = new (0, $ilwiq.DataTexture)(buffer, width, height, (0, $ilwiq.RGBAFormat), (0, $ilwiq.HalfFloatType));
        result.minFilter = (0, $ilwiq.LinearMipMapLinearFilter);
        result.magFilter = (0, $ilwiq.LinearFilter);
        result.wrapS = (0, $ilwiq.RepeatWrapping);
        result.wrapT = (0, $ilwiq.RepeatWrapping);
        result.mapping = (0, $ilwiq.EquirectangularReflectionMapping);
        result.needsUpdate = true;
        return result;
    }
    dispose() {
        this._quad.dispose();
    }
}

});



//# sourceMappingURL=areaLight.1c24b9b9.js.map
